export default __webpack_public_path__ + "static/media/p2023-36.bd92a911.jpeg";